module.exports = __webpack_public_path__ + "img/live-active.39bda659.png";